/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /catalog/microsoft-365
 */
export interface Microsoft365RequestBuilder extends BaseRequestBuilder<Microsoft365RequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<Microsoft365RequestBuilderGetQueryParameters> | undefined) : Promise<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<Microsoft365RequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface Microsoft365RequestBuilderGetQueryParameters {
    coupon?: string;
}
/**
 * Uri template for the request builder.
 */
export const Microsoft365RequestBuilderUriTemplate = "{+baseurl}/catalog/microsoft-365{?coupon*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const Microsoft365RequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: Microsoft365RequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
